export { wrapPageElement } from './gatsby-ssr'
